import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { useEffect } from "react";
import { Redirect, Route, Router as WouterRouter, Switch, useLocation } from "wouter";
import { applyRouteSurfaceForPath } from "./lib/routeSurface";

/** Alinha rotas com `base` do Vite (ex.: `/` ou `/sistema/` em subpasta). */
function wouterBaseFromVite(): string | undefined {
  const raw = import.meta.env.BASE_URL;
  if (!raw || raw === "/") return undefined;
  const trimmed = raw.replace(/\/$/, "");
  return trimmed === "" ? undefined : trimmed;
}
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import { ClientConfigProvider } from "./contexts/ClientConfigContext";
import Home from "./pages/Home";
import ConfigEstoque from "./pages/ConfigEstoque";
import CadastroInsumo from "./pages/CadastroInsumo";
import HistoricoConferencias from "./pages/HistoricoConferencias";
import ComandasPage from "./pages/ComandasPage";
import CaixaAuthPage from "./pages/CaixaAuthPage";
import CardapioPage from "./pages/cardapio/CardapioPage";
import GarcomAuthPage from "./pages/garcom/GarcomAuthPage";
import CadastroEmpresaPage from "./pages/CadastroEmpresaPage";
import AiStockMobileCapturePage from "./pages/AiStockMobileCapturePage";

function RouteSurfaceController() {
  const [location] = useLocation();

  useEffect(() => {
    applyRouteSurfaceForPath(location);
  }, [location]);

  return null;
}

function AppRoutes() {
  return (
    <Switch>
      <Route path="/estoque/ai-captura/:token" component={AiStockMobileCapturePage} />
      <Route path="/config-estoque" component={ConfigEstoque} />
      <Route path="/cadastro-insumo" component={CadastroInsumo} />
      <Route path="/historico-conferencias" component={HistoricoConferencias} />
      <Route path="/avisos">
        <Redirect to="/dashboard" />
      </Route>
      {/* URLs antigas → canônicas */}
      <Route path="/produtos">
        <Redirect to="/itens/produtos" />
      </Route>
      <Route path="/insumos">
        <Redirect to="/itens/insumos" />
      </Route>
      <Route path="/vendas">
        <Redirect to="/financeiro/vendas" />
      </Route>
      <Route path="/despesas">
        <Redirect to="/financeiro/despesas" />
      </Route>
      <Route path="/fornecedores">
        <Redirect to="/pagamentos" />
      </Route>
      <Route path="/itens/produtos/novo" component={Home} />
      <Route path="/itens/produtos/:id/editar" component={Home} />
      <Route path="/itens/produtos" component={Home} />
      <Route path="/meu-perfil">
        <Redirect to="/config" />
      </Route>
      <Route path="/config/usuarios" component={Home} />
      <Route path="/config/senha" component={Home} />
      <Route path="/itens/insumos" component={Home} />
      <Route path="/itens" component={Home} />
      <Route path="/dashboard" component={Home} />
      <Route path="/entradas" component={Home} />
      <Route path="/estoque" component={Home} />
      <Route path="/compras">
        <Redirect to="/reposicao" />
      </Route>
      <Route path="/reposicao" component={Home} />
      <Route path="/desperdicios" component={Home} />
      <Route path="/financeiro/vendas" component={Home} />
      <Route path="/financeiro/despesas" component={Home} />
      <Route path="/financeiro/compras" component={Home} />
      <Route path="/financeiro/outros" component={Home} />
      <Route path="/financeiro">
        <Redirect to="/financeiro/vendas" />
      </Route>
      <Route path="/pagamentos" component={Home} />
      <Route path="/conferencia" component={Home} />
      <Route path="/marketing" component={Home} />
      <Route path="/cadastros/parceiros" component={Home} />
      <Route path="/cadastros">
        <Redirect to="/cadastros/parceiros" />
      </Route>
      <Route path="/config" component={Home} />
      <Route path="/caixa" component={CaixaAuthPage} />
      <Route path="/garcom" component={GarcomAuthPage} />
      <Route path="/comandas">
        <Redirect to="/kds" />
      </Route>
      <Route path="/kds" component={ComandasPage} />
      <Route path="/cardapio/:mesa" component={CardapioPage} />
      <Route path="/cardapio" component={CardapioPage} />
      <Route path="/cadastro-de-empresa" component={CadastroEmpresaPage} />
      <Route path="/" component={Home} />
      <Route path="/404" component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  const wouterBase = wouterBaseFromVite();
  return (
    <ErrorBoundary>
      <ClientConfigProvider>
        <ThemeProvider
          defaultTheme="light"
          // switchable
        >
          <TooltipProvider>
            <Toaster />
            <WouterRouter base={wouterBase}>
              <RouteSurfaceController />
              <AppRoutes />
            </WouterRouter>
          </TooltipProvider>
        </ThemeProvider>
      </ClientConfigProvider>
    </ErrorBoundary>
  );
}

export default App;
